<template>
  <div
    class="custom-info-widget vuestic-widget no-padding no-v-padding"
    :class="theme"
  >
    <div class="info-box-data">
      <div class="info-box-image" :class="{ error }">
        <img
          :src="require(`@/assets/images/icon-${image}.svg`)"
          :alt="titleSmall"
        />
      </div>
      <div class="info-box-text">
        <span class="title-small">{{ titleSmall }}</span>
        <span class="value">
          {{ valueToDisplay }}
        </span>
      </div>
    </div>
    <div class="info-box-extra-data">
      <p class="title-large" v-if="!linkPath">{{ titleLarge }}</p>
      <span class="extra-info" :class="{ 'text-danger': error }" v-if="info">{{
        info
      }}</span>
      <router-link :to="linkPath" v-if="linkPath && !popup">{{
        linkText
      }}</router-link>
      <router-link
        to="/"
        v-if="linkPath && popup"
        @click.prevent.native="$store.dispatch('togglePopup', true)"
        >{{ linkText }}</router-link
      >
    </div>
    <app-popup v-if="popup">
      <template slot="popup-content">
        <h4 class="text-primary">Balance Refill</h4>
        <div class="px-4">
          <div class="account-details">
            <p>
              Kindly find below the KSA Bank information to refill your balance
            </p>
            <span>
              <strong>KSA Bank:</strong> AlRajhi (www.alrajhibank.com)
            </span>
            <br />
            <span> <strong>Swift Code:</strong> RJHISARI </span>

            <br />
            <span>
              <strong>Account Name:</strong>
              Mawjet Al wasaet for Information Technology
            </span>
            <br />
            <span> <strong>IBAN:</strong> SA2980000449608010688868 </span>
          </div>
          <div class="va-row buttons-container w-100 justify--center">
            <div class="flex md6 xs12">
              <button
                type="button"
                class="btn btn-primary btn-block btn-micro"
                @click="$store.dispatch('togglePopup', false)"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </template>
    </app-popup>
  </div>
</template>
<script>
export default {
  name: 'InfoWidget',
  props: {
    image: {
      required: true,
      type: String
    },
    titleSmall: {
      required: true,
      type: String
    },
    titleLarge: {
      required: false,
      type: String
    },
    value: {
      required: true,
      type: Object
    },
    info: {
      required: false,
      type: String
    },
    linkText: {
      required: false,
      type: String
    },
    linkPath: {
      required: false,
      type: String
    },
    theme: {
      required: false,
      type: String,
      default: 'light'
    },
    popup: {
      required: false,
      type: Boolean,
      default: false
    },
    error: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    valueToDisplay() {
      let value = {}
      if (Object.keys(this.value).length > 2) {
        value = `${this.value.hours}H ${this.value.minutes}M ${this.value.seconds}S`
      } else {
        value = `${this.value.amount} ${this.value.currency}`
      }
      return value
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-info-widget {
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
  margin-top: 40px;
  width: 320px;
  margin-right: 15px;
  .info-box-data {
    position: relative;
    padding-left: 120px;
    border-bottom: 2px solid $light-gray;
    .info-box-text {
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: space-between;
      height: 105px;

      .title-small {
        margin-top: 10px;
        font-size: 1rem;
        color: darken($gray, 20%);
        font-weight: 200;
      }
      .value {
        font-size: 1.3rem;
        font-weight: 400;
        text-overflow: ellipsis;
      }
    }
    .info-box-image {
      position: absolute;
      left: 5px;
      top: -40px;
      width: 100px;
      height: 100px;
      background-color: #4d4d4d;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      box-shadow: $blueish-box-shadow;
      &.error {
        background-color: $red;
        box-shadow: unset;
      }
      img {
        height: 55px;
        width: auto;
      }
    }
  }
  .info-box-extra-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60px;
    .title-large,
    a {
      font-size: 1.2rem;
      font-weight: 400;
      margin-bottom: 0;
      margin-top: 5px;
      line-height: 1.5;
    }
    .title-large {
      color: $blue;
    }
    .extra-info {
      font-size: 1rem;
      font-weight: 200;
      color: darken($gray, 20%);
      &.text-danger {
        font-weight: bold;
      }
    }
  }

  &.dark {
    background-color: $darkblue;
    .info-box-data {
      border-color: $blue;
      .info-box-text {
        color: $white;
        .title-small {
          color: $white;
        }
      }
    }

    .title-large {
      color: $white;
    }
    .extra-info {
      color: $white;
    }
  }
  h4 {
    margin-top: 0;
  }
  .account-details {
    max-height: 200px;
    overflow: auto;
    padding: 10px;
    border: 1px solid lighten($gray, 20%);
    border-radius: 0.5rem;
    margin-bottom: 10px;
  }
}
</style>
